import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import { useNavigate } from 'react-router-dom';

const ArcAnimation = () => {

  const navigate = useNavigate();

  const svg1Ref = useRef();
  const svg2Ref = useRef();
  const svg3Ref = useRef();
  const svg4Ref = useRef();
  const svg5Ref = useRef();
  const svg6Ref = useRef();

  // arcTween functions (same as your code)
  const arcTween = (arc, newAngle) => {
    return function (d) {
      const interpolate = d3.interpolate(d.endAngle, newAngle);
      return function (t) {
        d.endAngle = interpolate(t);
        return arc(d);
      };
    };
  };

  useEffect(() => {

    const tau = 2 * Math.PI;

    const arc1 = d3.arc().innerRadius(22.5).outerRadius(45).startAngle(0.75 * tau);
    const arc2 = d3.arc().innerRadius(22.5).outerRadius(45).startAngle(0.25 * tau);
    const arc3 = d3.arc().innerRadius(22.5).outerRadius(45).startAngle(-0.5 * tau);
    const arc4 = d3.arc().innerRadius(22.5).outerRadius(45).startAngle(0 * tau);
    const arc5 = d3.arc().innerRadius(22.5).outerRadius(50).startAngle(0.5 * tau);
    const arc6 = d3.arc().innerRadius(22.5).outerRadius(50).startAngle(0 * tau);

    const svg1 = d3.select(svg1Ref.current);
    const svg2 = d3.select(svg2Ref.current);
    const svg3 = d3.select(svg3Ref.current);
    const svg4 = d3.select(svg4Ref.current);
    const svg5 = d3.select(svg5Ref.current);
    const svg6 = d3.select(svg6Ref.current);

    const width1 = +svg1.attr('width');
    const height1 = +svg1.attr('height');
    const g1 = svg1.append('g').attr('transform', `translate(${width1 / 2},${height1 / 2})`);

    const width2 = +svg2.attr('width');
    const height2 = +svg2.attr('height');
    const g2 = svg2.append('g').attr('transform', `translate(${width2 / 2},${height2 / 2})`);

    const width3 = +svg3.attr('width');
    const height3 = +svg3.attr('height');
    const g3 = svg3.append('g').attr('transform', `translate(${width3 / 2},${height3 / 2})`);

    const width4 = +svg4.attr('width');
    const height4 = +svg4.attr('height');
    const g4 = svg4.append('g').attr('transform', `translate(${width4 / 2},${height4 / 2})`);

    const width5 = +svg5.attr('width');
    const height5 = +svg5.attr('height');
    const g5 = svg5.append('g').attr('transform', `translate(${width5 / 2},${height5 / 2})`);

    const width6 = +svg6.attr('width');
    const height6 = +svg6.attr('height');
    const g6 = svg6.append('g').attr('transform', `translate(${width6 / 2},${height6 / 2})`);

    // Background arcs
    g1.append('path').datum({ endAngle: tau }).style('fill', 'transparent').attr('d', arc1);
    g2.append('path').datum({ endAngle: tau }).style('fill', 'transparent').attr('d', arc2);
    g3.append('path').datum({ endAngle: tau }).style('fill', 'transparent').attr('d', arc3);
    g4.append('path').datum({ endAngle: tau }).style('fill', 'transparent').attr('d', arc4);
    g5.append('path').datum({ endAngle: tau }).style('fill', 'transparent').attr('d', arc5);
    g6.append('path').datum({ endAngle: tau }).style('fill', 'transparent').attr('d', arc6);

    // Foreground arcs
    const foreground1 = g1
      .append('path')
      .datum({ endAngle: 0.75 * tau })
      .style('fill', '#EF4939')
      .attr('d', arc1);
    const foreground2 = g2
      .append('path')
      .datum({ endAngle: 0.25 * tau })
      .style('fill', '#EF4939')
      .attr('d', arc2);
    const foreground3 = g3
      .append('path')
      .datum({ endAngle: -0.5 * tau })
      .style('fill', '#EF4939')
      .attr('d', arc3);
    const foreground4 = g4
      .append('path')
      .datum({ endAngle: 0 * tau })
      .style('fill', '#EF4939')
      .attr('d', arc4);
    const foreground5 = g5
      .append('path')
      .datum({ endAngle: 0.75 * tau })
      .style('fill', '#FFFFFF')
      .attr('d', arc5);
    const foreground6 = g6
      .append('path')
      .datum({ endAngle: 0.25 * tau })
      .style('fill', '#FFFFFF')
      .attr('d', arc6);

    // Timer and transitions
    let runOnce = 0;
    const timer1 = d3.timer((elapsed) => {
      if (runOnce === 0) {
        foreground1
          .transition()
          .ease(d3.easeLinear)
          .duration(400)
          .attrTween('d', arcTween(arc1, 0 * tau));
        foreground2
          .transition()
          .ease(d3.easeLinear)
          .duration(400)
          .attrTween('d', arcTween(arc2, -0.5 * tau));
        foreground3
          .transition()
          .ease(d3.easeLinear)
          .delay(400)
          .duration(400)
          .attrTween('d', arcTween(arc3, 0.4 * tau));
        foreground4
          .transition()
          .ease(d3.easeLinear)
          .delay(400)
          .duration(400)
          .attrTween('d', arcTween(arc4, 0.9 * tau));
        // foreground5
        //   .transition()
        //   .ease(d3.easeLinear)
        //   .duration(400)
        //   .attrTween('d', arcTween(arc5, 0.6 * tau));
        // foreground6
        //   .transition()
        //   .ease(d3.easeLinear)
        //   .duration(400)
        //   .attrTween('d', arcTween(arc6, 0 * tau));
        runOnce = 1;

        // Handle delayed actions (adjust according to React)
        setTimeout(() => {
          // Additional UI updates for React components can go here
          navigate('/home');
        }, 1600);
      }
      if (elapsed > 3000) {
        // Perform further actions (like toggling classes)
        timer1.stop();
      }
    }, 500);

    return () => {
      timer1.stop();
    };
  }, [navigate]);

  return (
	<div className = "logoHolder" id = "animated-ring">
		<div className = "logoBox" id = "box_1">
			<svg ref={svg3Ref} viewBox= "0 0 100 100" width= "100" height= "100" className = "logoAnim" id = "anim3"></svg>
		</div>
		<div className = "logoBox" id = "box_2">
			<svg ref={svg1Ref} viewBox= "0 0 100 100" width= "100" height= "100" className = "logoAnim" id = "anim1"></svg>
		</div>
		<div className = "logoBox" id = "box_3">
			<svg ref={svg2Ref} viewBox= "0 0 100 100" width= "100" height= "100" className = "logoAnim" id = "anim2"></svg>
		</div>
		<div className = "logoBox" id = "box_4">
			<svg ref={svg4Ref} viewBox= "0 0 100 100" width= "100" height= "100" className = "logoAnim" id = "anim4"></svg>
		</div>
		<div className = "logoBox" id = "box_5">
			<svg ref={svg5Ref} viewBox= "0 0 100 100" width= "100" height= "100" className = "logoAnim" id = "anim5"></svg>
		</div>
		<div className = "logoBox" id = "box_6">
			<svg ref={svg6Ref} viewBox= "0 0 100 100" width= "100" height= "100" className = "logoAnim" id = "anim6"></svg>
		</div>
	</div>
  );
};

export default ArcAnimation;
